module.exports = __webpack_public_path__ + "img/urbanutvikling_smvf.28435582.jpg";